<!-- 癌症筛查 -->
<template>
  <div id="cancer-inspect">
    <vice-title>
      <h3>{{ this.$t("lang.BetterMedicalCare.cancerScreening") }}</h3>
    </vice-title>
    <div class="cancer-detail">
      <div :class="language">
        <p>
          {{ this.$t("lang.BetterMedicalCare.cancerScreeningDetailTop") }}
        </p>
        <p>
          {{ this.$t("lang.BetterMedicalCare.cancerScreeningDetailBottom") }}
        </p>
      </div>
      <div class="right">
        <img src="../../assets/images/bestMedicalCare/xin.png" alt="" />
      </div>
    </div>
    <div class="notes">
      <h3>{{ this.$t("lang.BetterMedicalCare.notes") }}</h3>
      <p>
        {{ this.$t("lang.BetterMedicalCare.psFirst") }}
      </p>
      <p>
        {{ this.$t("lang.BetterMedicalCare.psSecond") }}
      </p>
      <p>
        {{ this.$t("lang.BetterMedicalCare.psThird") }}
      </p>
    </div>
    <div class="project-details">
      <a
        href="http://47.99.101.7:8080/pdf/体检项目表.pdf"
        target="_blank"
        style="margin-right: 100px"
      >
        <div>
          <p>{{ this.$t("lang.BetterMedicalCare.physicalExamination") }}</p>
          <p class="iconfont">&#xe603;</p>
        </div>
      </a>
      <a href="http://47.99.101.7:8080/pdf/体检地点分布.pdf" target="_blank">
        <div>
          <p>
            {{ this.$t("lang.BetterMedicalCare.physicalExaminationLocation") }}
          </p>
          <p class="iconfont">&#xe603;</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import ViceTitle from "../ViceTitle";
export default {
  name: "CancerInspect",
  components: {
    ViceTitle
  },
  data() {
    return {
      language: ""
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.language = "left-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.language = "left";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#cancer-inspect {
  width: 75%;
  margin: 0 auto;
  overflow: hidden;
  .cancer-detail {
    display: flex;
    .left {
      /*margin: 0 30px;*/
      height: 100%;
      width: 45%;
      text-indent: 2em;
      line-height: 30px;
      font-size: 18px;
      color: #acacac;
      margin-right: 30px;
    }
    .left-us {
      height: 100%;
      width: 45%;
      text-indent: 2em;
      line-height: 24px;
      font-size: 14px;
      color: #acacac;
      margin-right: 30px;
    }
    .right {
      flex: 1;
      img {
        width: 100%;
      }
    }
  }
  .notes {
    color: #acacac;
    h3 {
      margin-top: 30px;
    }
    p {
      line-height: 27px;
      font-size: 14px;
    }
  }
  .project-details {
    margin-top: 70px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      font-size: 16px;
      color: $publicBlue;
      display: flex;
    }
  }
}
</style>
